import React, { useEffect } from 'react';
import {Link} from 'react-router-dom';
import kominfo from '../../assets/default-kominfo.jpg';
import detikImage from '../../assets/detikImage.jpg';
import metroTv from '../../assets/tanda_tangan_digital_20161124_192811.jpg';
import ttd from '../../assets/TTD.jpg';
import krJogja from '../../assets/tanda-tangan-digital-kominfo_20161122_140417.jpg';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    partialVisibilityGutter: 30 
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    partialVisibilityGutter: 30 
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 30 
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 30 
  },
};

export default () => {
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://unpkg.com/flickity@2/dist/flickity.pkgd.js";
  //   document.getElementsByClassName("main-carousel")[0].appendChild(script);
  // }, []);

  return (
    <section className="psre-tiga">
        <div className="container">
          <table className="table-borderless w-100 mb-5">
            <tr>
              <td>
                <p className="mb-0" style={{fontSize:'14px',fontWeight: '600'}}>Referensi dan Berita</p>
              </td>
              <td className="tb" style={{width: '65%'}}>
                <div style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)',width: '100%'}}></div>
              </td>
              <td class="text-right">
                <Link to='/event/blog' style={{fontSize: '13px',fontWeight:'600', color: '#0085C7'}}>Lihat Semua Berita & Blog</Link>
              </td>
            </tr>
          </table>
          <div className="row">
            <div className="col-lg-9 col-md-8 col-sm-12 col-12">
              <a target="_blank" href="https://www.kominfo.go.id/content/detail/21721/seminar-bimtek-pemanfaatan-dan-kekuatan-hukum-tanda-tangan-elektronik/0/live_streaming" style={{color: 'black'}}>
                <img className="mb-4" src={kominfo} alt="grey" style={{width: '100%', height: '400px', objectFit: 'cover'}} />
                <p style={{fontSize: '18px', fontWeight: '600', textAlign: 'justify'}}>Seminar & Bimtek : Pemanfaatan dan Kekuatan Hukum Tanda Tangan Elektronik</p>
                <div className="space-between mb-3">
                  <div className="d-flex">
                    <p className="text-muted ml-4">Live Streaming</p>
                  </div>
                </div>
              </a>
              <div style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)'}}></div>
              <Carousel 
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={false}
                autoPlaySpeed={2000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={2000}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                // deviceType={this.props.deviceType}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                partialVisbile={true}
              
              >
               {/* <div className="article-carousel" data-flickity=""> */}
                <div className=""style={{marginRight: 15}}><a target="_blank" href="https://inet.detik.com/cyberlife/d-3445859/membangun-identitas-digital-indonesia" style={{color: 'black'}}><img className="mb-4" src={detikImage} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                  <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Membangun Identitas Digital Indonesia</p>
                  <div className="space-between" style={{fontSize: '12px'}}>
                    <div>
                      <p className="text-muted">Satriyo Wibowo - detikInet</p>
                    </div>
                  </div>
                </a></div>
                <div className="" style={{marginRight: 15}}><a target="_blank" href="http://video.metrotvnews.com/q-a/Wb7jjvMN-menyikapi-media-cetak-di-tengah-derasnya-pengaruh-digitalisasi" style={{color: 'black'}}><img className="mb-4" src={metroTv} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                    <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Menyikapi Media Cetak di Tengah Derasnya Pengaruh Digitalisasi</p>
                    <div className="space-between" style={{fontSize: '12px'}}>
                      <div>
                        <p className="text-muted">MetroTV News</p>
                      </div>
                    </div>
                  </a></div>
                <div className="" style={{marginRight: 15}}><a target="_blank" href="https://www.thejakartapost.com/news/2016/11/14/ministry-encourages-use-of-digital-signatures.html" style={{color: 'black'}}><img className="mb-4" src={ttd} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                    <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Ministry encourages use of digital signatures for Indonesia citizen</p>
                    <div className="space-between" style={{fontSize: '12px'}}>
                      <div>
                        <p className="text-muted">The Jakarta Post</p>
                      </div>
                    </div>
                  </a></div>
                <div className="" style={{marginRight: 15}}><a target="_blank" href="https://krjogja.com/web/news/read/15708/Tanda_Tangan_Digital_Jamin_Keamanan_dan_Legalitas" style={{color: 'black'}}><img className="mb-4" src={krJogja} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                    <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Tanda Tangan Digital Jamin Keamanan dan Legalitas</p>
                    <div className="space-between" style={{fontSize: '12px'}}>
                      <div>
                        <p className="text-muted">Agus Sigit</p>
                      </div>
                    </div>
                  </a></div>
              {/* </div> */}
            </Carousel>
              {/* <div className="article-carousel" data-flickity="">
                <div className="carousel-cell"><a target="_blank" href="https://inet.detik.com/cyberlife/d-3445859/membangun-identitas-digital-indonesia" style={{color: 'black'}}><img className="mb-4" src={detikImage} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                  <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Membangun Identitas Digital Indonesia</p>
                  <div className="space-between" style={{fontSize: '12px'}}>
                    <div>
                      <p className="text-muted">Satriyo Wibowo - detikInet</p>
                    </div>
                  </div>
                </a></div>
                <div className="carousel-cell"><a target="_blank" href="http://video.metrotvnews.com/q-a/Wb7jjvMN-menyikapi-media-cetak-di-tengah-derasnya-pengaruh-digitalisasi" style={{color: 'black'}}><img className="mb-4" src={metroTv} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                    <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Menyikapi Media Cetak di Tengah Derasnya Pengaruh Digitalisasi</p>
                    <div className="space-between" style={{fontSize: '12px'}}>
                      <div>
                        <p className="text-muted">MetroTV News</p>
                      </div>
                    </div>
                  </a></div>
                <div className="carousel-cell"><a target="_blank" href="https://www.thejakartapost.com/news/2016/11/14/ministry-encourages-use-of-digital-signatures.html" style={{color: 'black'}}><img className="mb-4" src={ttd} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                    <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Ministry encourages use of digital signatures for Indonesia citizen</p>
                    <div className="space-between" style={{fontSize: '12px'}}>
                      <div>
                        <p className="text-muted">The Jakarta Post</p>
                      </div>
                    </div>
                  </a></div>
                <div className="carousel-cell"><a target="_blank" href="https://krjogja.com/web/news/read/15708/Tanda_Tangan_Digital_Jamin_Keamanan_dan_Legalitas" style={{color: 'black'}}><img className="mb-4" src={krJogja} alt="grey" style={{width: '100%', height: '150px', objectFit: 'cover'}} />
                    <p className="clamp-word" style={{fontSize: '14px', fontWeight: '600', textAlign: 'justify'}}>Tanda Tangan Digital Jamin Keamanan dan Legalitas</p>
                    <div className="space-between" style={{fontSize: '12px'}}>
                      <div>
                        <p className="text-muted">Agus Sigit</p>
                      </div>
                    </div>
                  </a></div>
              </div>*/}
            </div> 
            <div className="col-lg-3 col-md-4 col-sm-12 col-12">
              <p style={{fontSize:'14px',fontWeight: '600'}}>Berita Populer Bulan Ini</p>
              <div style={{borderTop: '1px solid rgba(49, 49, 49, 0.12)', width: '100%', marginBottom: '20px'}}></div>
              <div className="mb-4"><a target="_blank" href="https://www.thejakartapost.com/news/2017/02/21/fintech-talk-fintech-and-electronic-signatures.html">
                  <p className="clamp-word" style={{fontSize: '16px', fontWeight: '600', textAlign: 'left', color: 'black'}}>Fintech Talk: Fintech and electronic signatures</p>
                  <div className="space-between" style={{fontSize: '12px'}}>
                    <div>
                    </div>
                    <p className="text-muted">The Jakarta Post</p>
                  </div>
                </a></div>
              <div className="mb-4"><a target="_blank" href="https://sumsel.tribunnews.com/2016/11/22/kominfo-giat-berikan-informasi-mengenai-manfaat-tanda-tangan-digital">
                  <p className="clamp-word" style={{fontSize: '16px', fontWeight: '600', textAlign: 'left', color: 'black'}}>Kominfo Giat Berikan Informasi Mengenai Manfaat Tanda Tangan Digital</p>
                  <div className="space-between" style={{fontSize: '12px'}}>
                    <div>
                    </div>
                    <p className="text-muted">Melisa Wulandari</p>
                  </div>
                </a></div>
              <div className="mb-4"><a target="_blank" href="https://money.kompas.com/read/2017/02/22/073000626/.fintech.dan.tanda.tangan.elektronik?page=all">
                  <p className="clamp-word" style={{fontSize: '16px',fontWeight: '600', textAlign: 'left', color: 'black'}}>"Fintech" dan Tanda Tangan Elektronik</p>
                  <div className="space-between" style={{fontSize: '12px'}}>
                    <div>
                    </div>
                    <p className="text-muted">Aprilia Ika</p>
                  </div>
                </a></div>
              <div className="mb-4"><a target="_blank" href="https://inet.detik.com/cyberlife/d-3603061/kebebasan-anonim-vs-kepatuhan-identitas">
                  <p className="clamp-word" style={{fontSize: '16px',fontWeight: '600', textAlign: 'left', color: 'black'}}>Kebebasan Anonim vs Kepatuhan Identitas</p>
                  <div className="space-between" style={{fontSize: '12px'}}>
                    <div>
                    </div>
                    <p className="text-muted">Satriyo Wibowo dan Anindito - detikInet</p>
                    {/* <p className="text-muted" style={{fontSize: '12px'}}>3 Komentar</p> */}
                  </div>
                </a></div>
              <div className="mb-4"><a target="_blank" href="https://makassar.tribunnews.com/2017/12/05/strategi-kominfo-2018-1000-startup-digital-8-juta-umkm-go-online-anda-jadi-bagian">
                  <p className="clamp-word" style={{fontSize: '16px',fontWeight: '600', textAlign: 'left', color: 'black'}}>Strategi Kominfo 2018: 1000 Startup Digital & 8 juta UMKM Go Online ...</p>
                  <div className="space-between" style={{fontSize: '12px'}}>
                    <div>
                    </div>
                    <p className="text-muted">Citizen Reporter</p>
                  </div>
                </a></div>
            </div>
          </div>
        </div>
      </section>
  )
}
